import React from 'react'
import project from '../../project'
// import Data from './Data'
// import BreachCodes from './BreachCodes'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import { Tracking219 } from './Tracking'
import { ajaxSetup } from 'jquery'
import axios from 'axios';

import "../assets/styles/home.scss"

import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

const environment = (location.hostname === "localhost") ? 'DEV' : 'PROD'; // PROD or DEV
const apiUrl = (environment === 'PROD') ? 'https://us-central1-ncau-editorial-dapi-prod.cloudfunctions.net/app/api/v1' : 'https://us-central1-ncau-editorial-dapi-dev.cloudfunctions.net/app/api/v1'
// Vote data
const apiURL_storage = (environment === 'PROD') ? 'https://storage.googleapis.com/dapi-prod-data/AFL2023sf2.json' : 'https://storage.googleapis.com/dapi-dev-data/AFL2023sf2.json'
// Players Data
const apiURL_storage_data = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/AFL2023sf2/prod/AFL2023sf2.json'
// API collection
const apiCollection = 'AFL2023sf2'

ajaxSetup({ cache: true })

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      view: 'team-1',
      firstInteraction: false,
      breach: null,
      SubscriptionUrl: '',
      siteDomain: '',
      siteCode: '',
      isMobApp: false,
      votingDisabled: false,
      voteData: null,
      voteDataStorage: null,
      sliderMin: 0,
      sliderMax: 10,
      team1name: null,
      team2name: null,
      data: undefined,
      slider1: 5,
      slider2: 5,
      slider3: 5,
      slider4: 5,
      slider5: 5,
      slider6: 5,
      slider7: 5,
      slider8: 5,
      slider9: 5,
      slider10: 5,
      slider11: 5,
      slider12: 5,
      slider13: 5,
      slider14: 5,
      slider15: 5,
      slider16: 5,
      slider17: 5,
      slider18: 5,
      slider19: 5,
      slider20: 5,
      slider21: 5,
      slider22: 5,
      slider23: 5,
      slider24: 5,
      slider25: 5,
      slider26: 5,
      slider27: 5,
      slider28: 5,
      slider29: 5,
      slider30: 5,
      slider31: 5,
      slider32: 5,
      slider33: 5,
      slider34: 5,
      slider35: 5,
      slider36: 5,
      slider37: 5,
      slider38: 5,
      slider39: 5,
      slider40: 5,
      slider41: 5,
      slider42: 5,
      slider43: 5,
      slider44: 5,
      slider45: 5,
      slider46: 5
    }

    this.siteCode = this.siteCode.bind(this)
    // this.checkBreach = this.checkBreach.bind(this)
    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    // this.addBodyEvents()

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    // this.checkBreach()
    this.loadData()
  }

  loadData () {
    
    axios.get(apiURL_storage_data)
    .then((response) => {
      // console.log('response', response)
      let titlesRemoved = response.data.values
      titlesRemoved.shift()

      // console.log('titlesRemoved', titlesRemoved)
      const name1 = titlesRemoved[0][4]
      const name2 = titlesRemoved[titlesRemoved.length - 1][4]
      


      this.setState({
        data: titlesRemoved,
        team1name: name1,
        team2name: name2
      }, function () {
        if ( this.state.breach === true ) {
          // this.dataSlash()
        }
        this.loadResults()
      });


    })
    .catch((err) => {
      console.log('err', err)
    })

    // this.loadResults()


  }

  flipTab () {
    if (Math.random() >= 0.5) {
      document.getElementById('nnd-navR').click() // PA
    } else {
      return
    }
  }
    
  loadResults () {
    
    // hit storage for PROD
    if (environment === 'PROD') {
      // console.log('Get Votes Storage')
      axios.get(apiURL_storage)
      .then((response) => {
        this.processItems(response.data.items)
        // console.log('response.data', response.data.items);
      })
      // .catch(err => console.error(err))
      .catch((err) => {
        console.log('err', err)
        console.error(err)
      })
    
    } else {
      // hit api direct fot testing/dev NOT FOR PROD
      
      axios.get(`${apiUrl}/vote/fetch`, {
        params: {
          projectName: apiCollection,
          collectionId: 'vote',
          count: 966, // Optional. Set a limit on the number of items returned. Default is 20.
          offset: 0, // Optional. Start offset in the collection. Offsets start at 0. 
        }
      })
      .then((res) => {
        const { count, endOffset, items, startOffset, total } = res.data
        // console.log('Fetched votes')
        // console.log('count', count)
        // console.log('endOffset', endOffset)
        // console.log('startOffset', startOffset)
        // console.log('items', items)
        // console.log('total', total)
        // setVoteData(items)

        this.processItems(items)

        this.setState({
          voteData: items
        })
      })
      .catch(err => console.error(err))
    }

    this.flipTab()
    
  }

  processItems (items) {
    // console.log('items', items)
    
    let thisState = this
    // console.log('thisState', thisState)

    let playersVotes = {}
    let totalPlayersVotes = 0

    items.forEach(function(element) {
      const playerId = element.categoryA.split('_')[0] //.replace('player', '')
      const scoreId = element.categoryA.split('_')[1]
      // console.log('player', playerId, scoreId, element.total)

      playersVotes[playerId] = playersVotes[playerId] || {};
      playersVotes[playerId][scoreId] = element.total
    })

    // console.log('playersVotes', playersVotes)

    Object.keys(playersVotes).forEach(function (key){
        // console.log(playersVotes[key]);

        let votes = playersVotes[key]
        let playerTotalVotes = 0
        let playerVoteScore = 0

        Object.keys(votes).forEach(function (key){
          playerTotalVotes = playerTotalVotes + votes[key]
          playerVoteScore = playerVoteScore + ( key * votes[key] )
        })

        totalPlayersVotes = totalPlayersVotes + playerTotalVotes

        const fansVoteAve = (playerTotalVotes === 0) ? 0 : playerVoteScore / playerTotalVotes
        let roundedFansVoteAve = (Math.round(fansVoteAve * 2) / 2).toFixed(1) // round nearest .5
        // console.log('roundedFansVoteAve', fansVoteAve, roundedFansVoteAve)

        roundedFansVoteAve = roundedFansVoteAve.replace('.0', '') // remove trailing zero
        
        const playerID = parseInt( key.replace('player','') )
        // console.log('playerID', playerID, roundedFansVoteAve)

        const matchedPlayer = thisState.state.data.filter(player => parseInt(player[0]) === playerID);
        // console.log('matchedPlayer', matchedPlayer[0])
        if ( matchedPlayer[0] ) {
          // matchedPlayer[0].fans = roundedFansVoteAve
          // [3] represents object key for fans votes from the sheet position
          matchedPlayer[0][3] = roundedFansVoteAve
        }
        
    })

    // console.log('totalPlayersVotes', totalPlayersVotes)
    this.setState({
      voteData: items
    })

  }

  submitvote (e,id,voteBracket) {
    e.persist();
    e.target.classList.add(`nnd-voting`)

    const voteKey = 'player' + id + '_' + voteBracket
    // console.log('voteKey', voteKey)
    
    this.setState({
      votingDisabled: true
    })

    let voteData = this.state.voteData

    // submit the vote

    // SEND VOTE
    const documentId = voteData.filter( (el) => voteKey === el.categoryA )[0].docid
    // console.log('documentId', documentId)
    
    axios.post(`${apiUrl}/vote/send`, {
      projectName: apiCollection,
      collectionId: 'vote',
      documentId: documentId
    })
      .then((res) => {
        // console.log('res.data', res.data)
        // e.persist();
        setTimeout(function(){
          this.setState({votingDisabled:false})
          e.target.classList.remove(`nnd-voting`)
          e.target.textContent = `voted`
          e.target.classList.add(`nnd-voted`)
          // below removes click event
          let oldBut = e.target
          let newBut = oldBut.cloneNode(true)
          oldBut.parentNode.replaceChild(newBut, oldBut)

        }.bind(this),1000)


      })
      .catch((err) => {
        // console.error(err)
        setTimeout(function(){
          this.setState({votingDisabled:false})
          e.target.classList.remove(`nnd-voting`)
          e.target.textContent = `voted`
          e.target.classList.add(`nnd-voted`)
          // below removes click event
          let oldBut = e.target
          let newBut = oldBut.cloneNode(true)
          oldBut.parentNode.replaceChild(newBut, oldBut)
        }.bind(this),1000)
        
      })
    
    // end submit vote

  }

  setClassName (e, tabName) {
    if (tabName !== this.state.view) {
      // console.log('tabname', tabName)
      // console.log('e', e)
      
      // let header = document.getElementById(`nnd-header`)
      let container = document.getElementById(`nnd-container`)
      // console.log('container', container)
      document.getElementsByClassName(`nnd-header-active-${this.state.view}`)[0].classList.remove(`nnd-header-active-${this.state.view}`)
      document.getElementsByClassName(`nnd-active-${this.state.view}`)[0].classList.remove(`nnd-active-${this.state.view}`)
      e.target.classList.add(`nnd-active-${tabName}`)
      container.classList.add(`nnd-header-active-${tabName}`)
      const grid = document.querySelector('.nnd-cont-main')
      grid.classList.toggle('nnd-hide')
      setTimeout(() => {
        this.state.view = tabName
        grid.setAttribute('name', `nnd-${tabName}`)
        let ratingReaders = grid.querySelectorAll('.nnd-col-rating')
        /*ratingReaders.forEach((e) => {
          e.classList.toggle('nnd-active-people')
        })*/
        setTimeout(() => {
          grid.classList.toggle('nnd-hide')
          Tracking.trackPageImpression(tabName, project.name)
        }, 200)
      }, 200)
    }
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  siteCode (siteHostname) {
    let siteCode, siteDomain
    switch (siteHostname) {
      
      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break

      case 'www.codesportssit.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesports.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesportsuat.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break
      
      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        rsiteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break
      
      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break

      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }

  goLogin () {
    const loginButton = document.querySelectorAll('.header_log-in, .tgc-auth-buttons_login') // Mastheads, Regionals
    loginButton[0].click()
  }

  /*checkBreach () {

    // const whatSite = this.siteCode(window.location.hostname)
    // console.log('site', whatSite)

    const isDeskMobAttribute = document.body.getAttribute('data-device')
    // console.log('isDeskMobAttribute', isDeskMobAttribute)
    const isMobileApp = ( isDeskMobAttribute === 'mobile' || isDeskMobAttribute === 'desktop' ) ? false : true
    // console.log('isMobileApp', isMobileApp)

    // console.log('isMobileApp', isMobileApp);
    // console.log('window.utag_data', window.utag_data);
        
    if (isMobileApp) {
      this.state.breach = false
      this.state.isMobApp = true
      this.loadData()

    } else if (window.utag_data) {
      if( (typeof window.utag_data.net_platform !== "undefined") && (typeof window.utag_data.pc_memtype !== "undefined") ) {
          const currentDomain = window.location.hostname
          const currentUrl = window.location.href
          const netsite = this.siteCode(window.location.hostname)
          const netplatform = window.utag_data.net_platform
          const breachSourceCode = BreachCodes[netsite][netplatform]
          const subUrl = 'https://'
            + currentDomain
            + '/subscribe/news/1/'
            + '?sourceCode=' + breachSourceCode
            + '&dest=' + encodeURIComponent(currentUrl)
            + '&memtype=anonymous&mode=premium'
            + '&v21=dynamic-hot-control-score&V21spcbehaviour=append'

          this.state.SubscriptionUrl = subUrl
          this.state.breach = ( utag_data && utag_data.pc_memtype == "subscriber" ) ? false : true;
          this.loadData()

      }
      else {
          setTimeout(this.checkBreach, 250);
      }
    }
    else {
      setTimeout(this.checkBreach, 250);
    }
    
  }*/

  /*dataSlash () {
    let slashedData = []

    this.state.data.forEach(function(p) {
      if (p[0] < 4 ) {
        slashedData.push(p)
      } else if (p[0] > 23 && p[0] < 27) {
        slashedData.push(p)
      }
    })

    // let slashedData = this.state.data.slice(0, 20)

    this.setState({
      data: slashedData
    })
  }*/

  /*goSubscribe () {
    window.location.assign(this.state.SubscriptionUrl);
  }*/

  render() {
    const cards = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      // console.log('item.imagename', item)
      if (typeof this.state.data !== 'undefined') {
        return (
          <div key={item[0]} className={`nnd-row nnd-player-${item[0]} nnd-origin-team-${item[5]}`}>

            <div className="nnd-col-img">
              {item[6] ? <img src={require(`../assets/images/${item[6].trim()}.svg`)} /> : '' }
            </div>
            <div className="nnd-col-text">
              <h3>{ item[1] }</h3>
              {item[8] ? <p>{ item[8] }</p> : '' }
            </div>
           
            {/*<div className="nnd-col-rating">
              <span className='nnd-ratings-heading-expert'>Expert Rating</span>
              <span className='nnd-ratings-headingsub-expert'>{ item[6] }</span>
              <span className="nnd-ratings-expert">{ item[2] }</span>
              <span className='nnd-ratings-heading-fans'>Avg Fan Rating</span>
              <span className="nnd-ratings-fans">{ item[3] }</span>
            </div>*/}

            <div className="nnd-col-rating">
              <span className='nnd-ratings-expert'>
                <span className='nnd-ratings-heading-expert'>Expert Rating</span>
                <span className='nnd-ratings-headingsub-expert'>{ item[7] }</span>
                <span className="nnd-ratings-expert-score">{ item[2] }</span>
              </span>
              <span className='nnd-ratings-fan'>
                <span className='nnd-ratings-heading-fans'>Avg Fan Rating</span>
                <span className="nnd-ratings-fans-score">{ item[3] }</span>
              </span>
            </div>


            <div className="nnd-slider" data-slider-id={ item[0] }>
              <span className="nnd-rtp">Rate { item[1] }</span>
              <Slider min={this.state.sliderMin} max={this.state.sliderMax} step={0.5} defaultValue={this.state['slider' + item[0]]} onChange={value=>this.setState({['slider' + item[0]]: value})} />
              <button className="button nnd-submit" disabled={this.state.votingDisabled} onClick={(e) => { this.submitvote(e, item[0], this.state['slider' + item[0]]); e.preventDefault() }} >vote</button>
              <span className="nnd-sliderValue" >{this.state['slider' + item[0]]}</span>
            </div>
          </div>
        )
      }
    }) : ''

    // const isBreached = this.state.breach
    const isMobApp = this.state.isMobApp
    // const sponsorLink = 'https://ad.doubleclick.net/ddm/trackclk/N6069.2144923NEWSCORPAU/B28408194.346951623;dc_trk_aid=538304277;dc_trk_cid=178864848;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd='

    return (
      <div id="nnd-container" className={`nnd-header-active-team-1 ${isMobApp ? "nnd-mobileApp" : ""} `}>
        {/*<div className="nnd-sponsor"><a id="nnd-logo-link" href={sponsorLink} target="_blank" className="nnd-sponsor-logo-link"><img alt="TikTok" src={require('../assets/images/logo-tiktok.png')} /></a></div>*/}
        <h3 className="nnd-title"><span>AFL 2023</span>Semifinal 2</h3>
        <div className="nnd-navigation-bg"></div>
        <div className="nnd-navigation">
          <div className="nnd-nav-btns">
            <a id="nnd-navL" className="nnd-active-team-1" onClick={(e) => { this.setClassName(e, 'team-1'); e.preventDefault() }}>{ this.state.team1name }</a>
            {/*<span className="nnd-logo" >
              <img className="shield-ade" src={require('../assets/images/shield-ade.svg')} />
              <img className="shield-pa" src={require('../assets/images/shield-pa.svg')} />
            </span>*/}
            <a id="nnd-navR" onClick={(e) => { this.setClassName(e, 'team-2'); e.preventDefault() }}>{ this.state.team2name }</a>
          </div>
        </div>
        <div name="nnd-team-1" className="nnd-cont-main nnd-start-team">
          {cards}
        </div>

      </div>
      
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js